import { Button } from '@capturi/ui-components'
import { useModal } from '@capturi/use-modal'
import { Box, Card, CardBody, CardFooter, Text } from '@chakra-ui/react'
import { FC } from 'react'
import { Title } from '../../../../utils'
import { useOrganizationSftpUsers } from '../../../useManageSftp'
import { CreateSftpModal } from './CreateSftpModal'
import { ViewPassword } from './ViewPassword'

type Props = { organizationUid: string }

export const ManageSftp: FC<Props> = ({ organizationUid }) => {
  const { data = [] } = useOrganizationSftpUsers(organizationUid)
  const [show] = useModal(CreateSftpModal)
  const [showPassword] = useModal(ViewPassword)

  return (
    <Card>
      <CardBody>
        <Title>SFTP users</Title>
        {data.map((d) => (
          <Box
            _hover={{
              borderColor: 'primary.400',
            }}
            transition="all ease-in-out 200ms"
            cursor="pointer"
            onClick={() =>
              showPassword({
                organizationUid,
                username: d.username,
                userUid: d.id,
              })
            }
            my="2"
            key={d.id}
            borderLeft="5px solid"
            borderColor="primary.200"
            pl="2"
          >
            <Text>{d.username}</Text>
            <Text>{d.id}</Text>
            <Text>
              Last login{' '}
              {d.sftpLastLoginAt
                ? d.sftpLastLoginAt.toLocaleString('da-DK')
                : '-'}
            </Text>
          </Box>
        ))}
      </CardBody>
      <CardFooter justifyContent="flex-end">
        <Button
          primary
          onClick={() => {
            show({ organizationUid })
          }}
        >
          Create new sftp
        </Button>
      </CardFooter>
    </Card>
  )
}
